import { useQuery } from "@tanstack/react-query";
import { MediaTask } from "@coworker/types/lib/tasks/media";
import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import {
  duplicateTasksToParent,
  filterOngoingAndRecentTasks,
} from "@coworker/app/src/components/RoomSettings/utils/taskUtils";
import { TaskLinks } from "@coworker/app/src/components/RoomSettings/types/taskLink";
import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";

const fetchTasksByIds = async (taskIds: string[], taskLinks: TaskLinks) => {
  const SLICE_SIZE = 200;
  if (taskIds.length === 0) return [];

  const batchedTaskIds: string[][] = [];
  for (let i = 0; i < taskIds.length; i += SLICE_SIZE) {
    batchedTaskIds.push(taskIds.slice(i, i + SLICE_SIZE));
  }

  const allTasks: MediaTask[] = [];
  for (const batch of batchedTaskIds) {
    const url = `${TASKS_SERVICE_URL}/v1/tasks/by_ids?ids=${batch.join(",")}`;
    const { result } = await fetchAPI("GET", url);
    const responseTasks: MediaTask[] = result?.tasks || [];
    allTasks.push(...responseTasks);
  }

  const updatedTasks = duplicateTasksToParent(allTasks, taskLinks);
  return filterOngoingAndRecentTasks(updatedTasks);
};

export const useTasksByIds = (taskIds: string[], taskLinks: TaskLinks) => {
  const storeId = useStoreId();

  return useQuery({
    queryKey: ["tasks", taskIds.sort().join(","), storeId],
    queryFn: async () => await fetchTasksByIds(taskIds, taskLinks),
    enabled: taskIds.length > 0 && taskLinks.length > 0,
  });
};
